export const PROMOTED_THEME: { code: string; isBeta: boolean } = {
  code: 'patagonia',

  // This info should come from the api.
  // update once this PR is deployed:
  // https://tiendanube.atlassian.net/browse/LIG-589
  isBeta: false,
};
